import { codeableConceptLabel } from '@ctw/shared/api/fhir/codeable-concept';
import type { OperationOutcomeIssue } from 'fhir/r4';

export class OperationOutcomeIssueModel {
  public resource: OperationOutcomeIssue;

  public constructor(issue: OperationOutcomeIssue) {
    this.resource = issue;
  }

  public get display(): string {
    return (
      codeableConceptLabel(this.resource.details) ||
      this.resource.diagnostics ||
      `${this.resource.code} error`
    );
  }

  public get severity(): OperationOutcomeIssue['severity'] {
    return this.resource.severity;
  }
}
